export interface Paginated<T> {
  items: T[];
  /** Zero-based page index, clamped into range. */
  page: number;
  /** Number of pages; 0 for an empty list. */
  pageCount: number;
  /** 1-based inclusive index of the first item shown (0 when empty). */
  start: number;
  /** 1-based inclusive index of the last item shown (0 when empty). */
  end: number;
  total: number;
}

export const paginate = <T>(
  items: T[],
  page: number,
  pageSize: number
): Paginated<T> => {
  const total = items.length;
  const size = Math.max(1, Math.floor(pageSize) || 1);
  const pageCount = total === 0 ? 0 : Math.ceil(total / size);
  const requested = Number.isFinite(page) ? Math.floor(page) : 0;
  const clamped = Math.min(Math.max(requested, 0), Math.max(0, pageCount - 1));

  if (total === 0) {
    return { items: [], page: 0, pageCount: 0, start: 0, end: 0, total: 0 };
  }

  const from = clamped * size;
  const slice = items.slice(from, from + size);

  return {
    items: slice,
    page: clamped,
    pageCount,
    start: from + 1,
    end: from + slice.length,
    total,
  };
};
